import React from 'react';
import LegalPageLayout from './LegalPageLayout';

function PrivacyPolicy() {
	return (
		<LegalPageLayout title="Privacy Policy">
			<p>
				Movie Quotes Guesser respects your privacy. This policy explains what information we collect,
				how we use it, and the choices you have.
			</p>
			<h2>Information We Collect</h2>
			<ul>
				<li>Usage data such as pages visited, device type, browser, and general location.</li>
				<li>Information you provide when contacting us, like your email and message.</li>
			</ul>
			<h2>How We Use Information</h2>
			<ul>
				<li>To operate the game, improve gameplay, and understand feature usage.</li>
				<li>To respond to support requests or feedback you send us.</li>
				<li>To support advertising and analytics that help keep the site running.</li>
			</ul>
			<h2>Cookies & Advertising</h2>
			<p>
				We and our partners may use cookies or similar technologies to analyze site traffic and
				serve relevant ads. You can control cookies through your browser settings.
			</p>
			<h2>Data Sharing</h2>
			<p>
				We do not sell your personal data. We may share limited data with service providers that
				help us run the site (analytics, hosting, or advertising).
			</p>
			<h2>Contact</h2>
			<p>
				Questions or data requests? Email us at{' '}
				<a href="mailto:contact@moviequotesguesser.com">contact@moviequotesguesser.com</a>.
			</p>
		</LegalPageLayout>
	);
}

export default PrivacyPolicy;
